import type { UIViewInjectedProps } from '@uirouter/react';

import { getTranslatedString } from '@/utils';
import { api } from '@/api';
import { Drawer } from '@/components/drawer';
import { Upload } from '@/components/upload';
import { Col, message } from 'antd';
import type { RcFile } from 'antd/lib/upload';
import { AttachmentType } from '@/types/enums';
import { lotStore } from '@/stores';

export const LotsFromExcel = ({ transition }: UIViewInjectedProps) => {
  const request = async (fileList: RcFile[]) => {
    // only one file validation
    if (fileList.length !== 1) {
      message.error('Supports only one file');
      throw new Error('Invalid number of files');
    }

    // Excel file validation
    const validExtensions = ['.xls', '.xlsx'];
    const invalidFiles = fileList.filter(
      (file: RcFile) => !validExtensions.some((ext) => file.name.toLowerCase().endsWith(ext)),
    );
    if (invalidFiles.length > 0) {
      message.error('You can upload only Excel files');
      throw new Error('Invalid file extension');
    }

    const formData = new FormData();
    const file: RcFile = fileList[0];
    formData.append('file', file);
    // formData.append("objectId", null);
    formData.append('type', AttachmentType.Lot);

    await api.lots.createLotsFromExcel(formData).source;
    await lotStore.refresh();
    transition.router.stateService.go('base-layout.lots');
  };

  const onClose = () => {
    transition.router.stateService.go('base-layout.lots');
  };

  return (
    <Drawer onClose={onClose} visible={true} title={getTranslatedString('lots.create-from-excel')}>
      <Col>
        <Upload
          request={request}
          multiple={false}
          accept=".xls,.xlsx"
          title="Click or drag a lots Excel file here"
          description="Single .xls or .xlsx file."
        />
      </Col>
    </Drawer>
  );
};
